import { Link, useNavigate } from "react-router-dom"
import { consoleLog } from "../../utils/log-utils"

function CouponStoreItem(props){
    consoleLog("id",props.id)
    const navigate=useNavigate()
    const getStore=()=>{
        navigate("/uniqueStore",{state:{
            storeId:props.id,
            storeName:props.name,
             event:"orders",
        }})
    }
    return(
        <>
        <tr>
            <td>1</td>
            <td onClick={getStore}><Link >BVR</Link></td>
            <td>10</td>
            <td>1000</td>
            
        </tr>
        </>
    )
}

export default CouponStoreItem